import {
  accentColor,
  black,
  orange,
  truewhite,
  white,
  _profilegreen,
  _profilehrborder,
} from 'src/styles/colors'
import { fontWeightSemiBold } from 'src/styles/font'
import { rightCenterLine } from 'src/styles/mixins'
import styled, { css } from 'styled-components'

export const Section = styled.section`
  margin-bottom: 60px;
  h3 {
    margin: 10px 0 20px;
    font-size: 20px;
    font-weight: ${fontWeightSemiBold};
    background-color: ${white};
    ${rightCenterLine};
    ::after {
      background: ${black};
    }
  }
`

export const sectionBodyStyle = css`
  padding: 20px 12px;
  margin-bottom: 20px;
  background: ${truewhite};
  border-radius: 12px;
`

export const Label = styled.span<{ backgroundColor?: string }>`
  display: inline-block;
  font-size: 14px;
  color: ${truewhite};
  padding: 4px 6px;
  margin: 4px;
  border-radius: 3px;
  vertical-align: middle;
  white-space: nowrap;
  ${({ backgroundColor = _profilegreen }) => css`
    background-color: ${backgroundColor};
  `}
`

export const PositionLabel = styled(Label)`
  font-size: 12px;
  font-weight: bold;
`
export const PaidUserLabel = styled(Label)`
  font-size: 12px;
  font-weight: bold;
  background-color: ${orange};
`
export const CompanyItem = styled.p`
  padding: 12px 0;
  border-bottom: 2px solid ${_profilehrborder};
`

export const LabelsWrapper = styled.div`
  position: relative;
`

export const LabelsContent = styled.div<{
  blur?: boolean
}>`
  ${({ blur }) =>
    blur
      ? `
    padding: 8px 0;
    filter: blur(3.5px);
  `
      : ''}
`

export const HideItemOverlayWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  > p {
    padding: 8px 16px !important;
    border-radius: 4px;
    border: solid 1px ${accentColor};
    color: ${accentColor};
    font-weight: ${fontWeightSemiBold};
    background: #fff;
    text-align: center;
  }
`
